<template>
  <div>
    <b-row class="timesheets-details mt-3">
      <!-- button visible in mobile view to scroll to totalHours component -->
      <b-button
        v-if="isMobileView"
        id="scroll-button"
        variant="primary"
        :class="{'show': showScrollButton}"
        @click="scrollToTotalHours"
      >
        <i class="fa fa-angle-double-down"/>
      </b-button>

      <b-col v-for="(day, index) in timesheet.Days.Days" md="6"  sm="12" class = "col-xxl-3 col-llg-4">
        <TimesheetForm
          v-model="timesheet"
          :date="day.date"
          :day-index="index"
          :is-mobile-view="isMobileView"
          :timesheetStd="timesheetStd"
          :isAbsencesPerDays="isAbsencesPerDays"
          :isAbsenceManagement="isAbsenceManagement"
          :unitAbsences="unitAbsences"
          :isWorkedHoursValidation="isWorkedHoursValidation"
        />
      </b-col>

      <b-col  md="6"  sm="12" class = "col-xxl-3 col-llg-4">
        <TimesheetTotalHours
          ref="totalHours"
          id="total-hours"
          :submit-from-form="false" :timesheet="timesheet"
          :timesheetStd="timesheetStd"
        />
      </b-col>

    </b-row>

    <template v-if="!$store.getters['auth/isLoggedAs']">
      <TimesheetConfirmButtons
        :timesheet="timesheet"
        :timesheetStd="timesheetStd"
      />

    </template>
  </div>
</template>

<script>
  import TimesheetForm from "./TimesheetForm";
  import TimesheetTotalHours from "./TimesheetTotalHours";
  import TimesheetConfirmButtons from "./TimesheetConfirmButtons";

  export default {
    name: "WeeklyTimesheet",
    components: {TimesheetConfirmButtons, TimesheetTotalHours, TimesheetForm},
    props: {
      timesheet: null,
      isMobileView: {
        type: Boolean,
        default: false
      },
      timesheetStd: null
    },
    computed: {
      // related to show/hide scroll button on mobile view
      showScrollButton() {
        if (!this.totalHoursElementRec) {
          return false;
        }
        return !(this.totalHoursElementRec.top >= 0 &&
          this.totalHoursElementRec.left >= 0 &&
          this.totalHoursElementRec.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          this.totalHoursElementRec.right <= (window.innerWidth || document.documentElement.clientWidth))
      },
      isAbsenceManagement() {
        return !!(this.timesheet.Days.Absences && this.timesheet.Days.Absences[0].Managed === "Yes");
      },
    },
    data() {
      return {
        totalHoursElementRec: null,
        isAbsencesPerDays:false,
        isWorkedHoursValidation:false,
        unitAbsences:null
      }
    },
    mounted() {
        // related to show/hide scroll button on mobile view

        if (this.$refs.totalHours !== undefined && this.$refs.totalHours.$el !== undefined ) {
          window.addEventListener('scroll', () => {this.totalHoursElementRec =  this.$refs.totalHours.$el.getBoundingClientRect()});
          this.totalHoursElementRec =  this.$refs.totalHours.$el.getBoundingClientRect();
      }
      if (this.$store.getters['auth/scopeDefault'].is_absences_per_days === true) {
        this.isAbsencesPerDays = true;
      }
      if (this.$store.getters['auth/scopeDefault'].is_worked_hours_validation === true) {
        this.isWorkedHoursValidation = true;
      }
      this.unitAbsences = this.isAbsencesPerDays?'day':this.timesheet.Unit.toLowerCase();
    },
    created(){
      this.timesheet['LanguageID'] =null;
    },
    // related to show/hide scroll button on mobile view
    destroyed() {
      window.removeEventListener('scroll', () => {this.totalHoursElementRec =  this.$refs.totalHours.$el.getBoundingClientRect()});
    },
    methods: {
      scrollToTotalHours() {
        document.getElementById("total-hours").scrollIntoView();
      }
    }
  }
</script>

<style scoped lang="scss">
  #scroll-button {
    border-radius: 50%;

    /* place it at the bottom right corner */
    position: fixed;
    bottom: 30px;
    right: 30px;
    /* keep it at the top of everything else */
    z-index: 100;
    /* hide with opacity */
    opacity: 0;
    /* also add a translate effect */
    transform: translateY(100px);
    /* and a transition */
    transition: all 1s ease;
    &.show {
      opacity: 1;
      transform: translateY(0);
      transition: all 1s ease;
    }
  }
</style>
